export const footer: object = {
  footer: {
    findUsOn: 'Find us on',
  }
};
